export default __webpack_public_path__ + "static/media/ageGroup.c3bae6d4.svg";